import { Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, ChangeDetectorRef } from '@angular/core';
import { EChartOption } from 'echarts';

@Component({
  selector: 'ex-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartsComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() chartOption: EChartOption;


  constructor(
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    // echarts.init(document.getElementById('views-chart')).setOption(this.optionPieChart());
  }
  ngOnChanges() {
    this.cd.detectChanges();
  }

}
